import React from 'react';
import { Card, CardContent } from './ui/card';
import { Phone, Sparkles, CheckCircle } from 'lucide-react';

interface UpgradePromptProps {
  limit?: number;
  phone?: string;
}

const UpgradePrompt: React.FC<UpgradePromptProps> = ({
  limit = 10,
  phone = '+1 (866) 658-2220',
}) => {
  return (
    <Card className="border-brand-stroke bg-brand-subtle/30">
      <CardContent className="py-5 px-6">
        <div className="flex items-start gap-3 mb-4">
          <Sparkles className="h-5 w-5 text-brand flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="font-semibold text-base text-text-secondary">
              You've used all your free AI conversations this month!
            </h3>
          </div>
        </div>

        <p className="text-sm text-text-tertiary mb-3">
          Unlock unlimited AI-powered business insights with the{' '}
          <span className="font-semibold text-text-secondary">Octopos AI Business Suite</span>:
        </p>

        <ul className="space-y-2 mb-4">
          {[
            'Unlimited AI conversations & queries',
            'Advanced data visualizations & charts',
            'Export reports to CSV, PDF & more',
            'Priority support',
          ].map((feature, i) => (
            <li key={i} className="flex items-center gap-2 text-sm text-text-secondary">
              <CheckCircle className="h-4 w-4 text-green-600 flex-shrink-0" />
              {feature}
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2 p-3 rounded-lg bg-white border border-brand-stroke">
          <Phone className="h-4 w-4 text-brand flex-shrink-0" />
          <span className="text-sm text-text-secondary">
            Call <a href={`tel:${phone.replace(/\D/g, '')}`} className="font-semibold text-brand hover:underline">{phone}</a> to get started today!
          </span>
        </div>
      </CardContent>
    </Card>
  );
};

export default UpgradePrompt;
